module.exports = __webpack_public_path__ + "static/media/1101_chfPatient.48cb4c83.png";